// extracted by mini-css-extract-plugin
module.exports = {"introText":"style_introText__DqHLB"};
module.exports.__checksum = "028ec43a30cc"